


























import Vue from "vue";

import { PropsHasImage } from "../../models/chat";

import JzFlexSpacer from "../layout/JzFlexSpacer.vue";
import JzButton from "../control/JzButton.vue";
import JzIcon from "../image/JzIcon.vue";
import JzModal from "../panel/JzModal.vue";

import IconClose from "../../assets/icons/black/Close.svg";

interface Props extends PropsHasImage {
  // Optionally close modal when clicking the background
  closeOnBgClick: boolean;
  // Close icon
  iconClose: string;
}

interface Methods {
  close: () => void;
  onModalBgClick: () => void;
}

/**
 * decreaseTimer period is far from being optimized but easier to read
 *
 * @emit started
 * @emit closed
 * @emit timeout
 */
export default Vue.extend<{}, Methods, {}, Props>({
  name: "JzChatImgDialog",
  components: { JzButton, JzIcon, JzFlexSpacer, JzModal },

  props: {
    captions: { type: String, default: "" },
    closeOnBgClick: { type: Boolean, default: true },
    iconClose: { type: String, default: IconClose },
    imgUrl: { type: String, required: true }
  },

  data() {
    return {};
  },

  computed: {},

  methods: {
    close() {
      this.$emit("closed");
    },

    onModalBgClick() {
      if (this.closeOnBgClick) {
        this.$emit("closed");
      }
    }
  }
});
